<script lang="ts">
    import { onMount } from 'svelte';

    import { MultiSelectWide } from '../components/telematics/components/MultiSelectWide/MultiSelectWide';
    import type { Entry, EntryId } from '../components/telematics/components/MultiSelectWide/types';

    export let availableEntries: Entry[] = [
        { id: '1', name: 'jeden' },
        { id: '2', name: 'dwa' },
    ];
    export let selectedIds: EntryId[] = [];
    export let onChange: (selectedIds: EntryId[]) => void = () => {};
    export let disabled: boolean = false;
    export let minAllowedSelectedItems = 1;

    let root: HTMLElement;

    onMount(() => {
        render();
    });

    function render() {
        new MultiSelectWide(
            {
                parentRoot: root,
                multiple: true,
                availableEntries,
                selectedIds,
                // maxAllowedSelectedItems: 0,
                minAllowedSelectedItems,
                forceConvertIdToString: false,
            },
            {
                onChange: newSelectedIds => {
                    console.log('selectedIds:', newSelectedIds);
                    onChange(newSelectedIds);
                },
            }
        );
    }
</script>

<div bind:this={root} class:disabled />

<style>
    .disabled {
        pointer-events: none;
        opacity: 0.5;
    }
    .multi-select-wide {
        width: 100%;
    }
    .multi-select-wide-container {
        max-width: unset;
    }
</style>
